import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponseWithPagination,
  GetWhatsappTemplatesSchema,
  WhatsappTemplatesResponseDataSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetWhatsappTemplatesSchema>
type Response = DataResponseWithPagination<z.infer<typeof WhatsappTemplatesResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

export const getWhatsappTemplatesQueryKey = (query: Query = {}) => [
  "campaignsWhatsappTemplates",
  query,
]

type Props = {
  query?: Query
  onSuccess?: OnSuccessFn
  enabled?: boolean
}

export const whatsappTemplatesQuery = ({ query, onSuccess, enabled = true }: Props = {}) => {
  return queryOptions({
    queryKey: getWhatsappTemplatesQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/integrations/whatsapp/templates", {
        params: query,
      })
      onSuccess?.(data)
      return data.data
    },
    enabled,
  })
}
